(function () {
  'use strict';

  var SWIPER_SRC = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
  var swiperLoading = null;

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (swiperLoading) return swiperLoading;

    swiperLoading = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = SWIPER_SRC;
      script.defer = true;
      script.onload = function () {
        resolve(window.Swiper);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return swiperLoading;
  }

  function initCopyButtons(root, productId) {
    root.querySelectorAll('.pdp-revamp__coupons__copy').forEach(function (button) {
      if (button.dataset.pdpCouponsCopyInit === 'true') return;
      button.dataset.pdpCouponsCopyInit = 'true';

      button.addEventListener('click', function () {
        var codeToCopy = button.getAttribute('data-copy-code');
        if (!codeToCopy) {
          var couponCard = button.closest('.pdp-revamp__coupons__card');
          var codeElement = couponCard && couponCard.querySelector('.pdp-revamp__coupons__code');
          codeToCopy = codeElement ? codeElement.textContent.trim() : '';
        }
        if (!codeToCopy) return;

        if (typeof gtag === 'function') {
          gtag('event', 'coupon_selected', {
            pdp_product_id: productId || '',
            coupon_code: codeToCopy
          });
        }

        navigator.clipboard.writeText(codeToCopy).then(function () {
          button.classList.add('is-copied');
          window.setTimeout(function () {
            button.classList.remove('is-copied');
          }, 2000);
        });
      });
    });
  }

  function initCarousel(root) {
    if (!root || root.dataset.pdpCouponsInit === 'true') return;

    var carousel = root.querySelector('[data-pdp-coupons-carousel]');
    if (!carousel) return;

    root.dataset.pdpCouponsInit = 'true';

    var pagination = root.querySelector('[data-pdp-coupons-pagination]');
    var productId = root.getAttribute('data-product-id');

    loadSwiper()
      .then(function (Swiper) {
        if (carousel.swiper) return;

        new Swiper(carousel, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          freeMode: true,
          grabCursor: true,
          watchOverflow: true,
          centerInsufficientSlides: false,
          pagination: pagination
            ? {
                el: pagination,
                clickable: true
              }
            : undefined
        });

        if (window.AnimationHandler && typeof window.AnimationHandler.init === 'function') {
          window.AnimationHandler.init();
        }
      })
      .catch(function () {});

    initCopyButtons(root, productId);
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-pdp-coupons]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
